import { render, staticRenderFns } from "./ListDeliveryData.vue?vue&type=template&id=758152e2&scoped=true&"
import script from "./ListDeliveryData.vue?vue&type=script&lang=ts&"
export * from "./ListDeliveryData.vue?vue&type=script&lang=ts&"
import style0 from "./ListDeliveryData.vue?vue&type=style&index=0&id=758152e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758152e2",
  null
  
)

export default component.exports